import { render, staticRenderFns } from "./OrdersChart.vue?vue&type=template&id=36fa9310&scoped=true&"
import script from "./OrdersChart.vue?vue&type=script&lang=js&"
export * from "./OrdersChart.vue?vue&type=script&lang=js&"
import style0 from "./OrdersChart.vue?vue&type=style&index=0&id=36fa9310&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa9310",
  null
  
)

export default component.exports